import pages from "pages/reducer";
import components from "components/reducer"

const reducers = {
  ...pages.reducer,
  ...components.reducer
};

const actions = {
  ...pages.actions,
  ...components.actions
};

const index = {
  reducers,
  actions,
};

export default index;